import { Category, LocationScope, TimeScope } from "generated/graphql";
import { SortState } from "store/filters";
import { useQueryParamObject } from "polyrouter";

export type InsightQueryParams = "InsightsFilterState";

export type InsightFilterState = {
  locationScope?: LocationScope;
  category?: Category | null | undefined;
  date?: TimeScope;
  site?: string;
  sort?: SortState | undefined;
  insight?: string;
};

export const defaultFilterState: InsightFilterState = {
  locationScope: undefined,
  date: undefined,
  site: undefined,
  sort: undefined,
  category: undefined,
  insight: undefined
};

export type SetInsightFilter = (paramsObj: InsightFilterState) => void;

export const usePriorityFilter: () => [
  InsightFilterState,
  SetInsightFilter,
  () => void
] = () => {
  const [urlState, setFilter, clear] = useQueryParamObject<
    InsightQueryParams,
    InsightFilterState
  >("InsightsFilterState");
  const filterState = urlState || defaultFilterState;
  return [filterState, setFilter, clear];
};
